module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.areCookiesEnabled) ? _c('LayoutGeneral', {
    staticClass: "c-modal--notification",
    attrs: {
      "show-close-button": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "header"
  }), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', [_c('i', {
    staticClass: "c-icon c-icon--cookie"
  }), _vm._v(" "), _c('h4', {
    staticClass: "c-modal--notification__title"
  }, [_vm._v(_vm._s(_vm.$t('cookie.disabled')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--notification__description"
  }, [_vm._v(_vm._s(_vm.$t('cookie.enable')))])])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09a46780"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Login/components/NoCookiesModal.vue
// module id = 316
// module chunks = 22